export default "__VITE_ASSET__e44e074b__"